// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.pDwMgleAGdtwIU, .W44URgoh0fSdK1) {
  word-break: break-word;
  word-wrap: break-word;
  overflow-wrap: break-word;
}
:where(.pDwMgleAGdtwIU, .W44URgoh0fSdK1) a {
  color: var(--ds-link, #0c66e4);
}
:where(.pDwMgleAGdtwIU, .W44URgoh0fSdK1) h1 {
  font-weight: 500;
  margin-bottom: 0;
  margin-top: 1.667em;
}
:where(.pDwMgleAGdtwIU, .W44URgoh0fSdK1) h2 {
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 0;
  margin-top: 1.8em;
}
:where(.pDwMgleAGdtwIU, .W44URgoh0fSdK1) h3 {
  font-size: 16px;
  font-weight: 600;
  margin-top: 2em;
}
:where(.pDwMgleAGdtwIU, .W44URgoh0fSdK1) h4 {
  font-size: 14px;
  font-weight: 600;
  margin-top: 1.357em;
}
:where(.pDwMgleAGdtwIU, .W44URgoh0fSdK1) h5 {
  font-size: 12px;
  font-weight: 600;
  margin-top: 1.667em;
}
:where(.pDwMgleAGdtwIU, .W44URgoh0fSdK1) h6 {
  color: var(--ds-text, #172b4d);
  font-size: 11px;
  font-weight: 700;
  margin-top: 1.455em;
}
:where(.pDwMgleAGdtwIU, .W44URgoh0fSdK1) p {
  margin-bottom: 0;
  margin-top: 12px;
}
:where(.pDwMgleAGdtwIU, .W44URgoh0fSdK1) p:first-child,
:where(.pDwMgleAGdtwIU, .W44URgoh0fSdK1) h1:first-child,
:where(.pDwMgleAGdtwIU, .W44URgoh0fSdK1) h2:first-child,
:where(.pDwMgleAGdtwIU, .W44URgoh0fSdK1) h3:first-child,
:where(.pDwMgleAGdtwIU, .W44URgoh0fSdK1) h4:first-child,
:where(.pDwMgleAGdtwIU, .W44URgoh0fSdK1) h5:first-child,
:where(.pDwMgleAGdtwIU, .W44URgoh0fSdK1) h6:first-child {
  margin-top: 0;
}
:where(.pDwMgleAGdtwIU, .W44URgoh0fSdK1) blockquote {
  border-left: 2px solid var(--ds-border, #091e4224);
  box-sizing: border-box;
  color: var(--ds-text, #172b4d);
  margin: 12px 0 0 0;
  padding-left: 16px;
}
:where(.pDwMgleAGdtwIU, .W44URgoh0fSdK1) ol,
:where(.pDwMgleAGdtwIU, .W44URgoh0fSdK1) ul {
  margin: 14px 0;
  padding: 0 0 0 24px;
}
:where(.pDwMgleAGdtwIU, .W44URgoh0fSdK1) ol ol,
:where(.pDwMgleAGdtwIU, .W44URgoh0fSdK1) ul ol,
:where(.pDwMgleAGdtwIU, .W44URgoh0fSdK1) ol ul,
:where(.pDwMgleAGdtwIU, .W44URgoh0fSdK1) ul ul {
  margin: 0;
}
:where(.pDwMgleAGdtwIU, .W44URgoh0fSdK1) ol li,
:where(.pDwMgleAGdtwIU, .W44URgoh0fSdK1) ul li {
  line-height: 24px;
  margin: 0;
}
:where(.pDwMgleAGdtwIU, .W44URgoh0fSdK1) ul > li {
  list-style: disc;
}
:where(.pDwMgleAGdtwIU, .W44URgoh0fSdK1) ul > li ul > li {
  list-style: circle;
}
:where(.pDwMgleAGdtwIU, .W44URgoh0fSdK1) ul > li ul > li ul > li {
  list-style: square;
}
:where(.pDwMgleAGdtwIU, .W44URgoh0fSdK1) ul > li ul > li ul > li ul > li {
  list-style: disc;
}
:where(.pDwMgleAGdtwIU, .W44URgoh0fSdK1) ul > li ul > li ul > li ul > li ul > li {
  list-style: circle;
}
:where(.pDwMgleAGdtwIU, .W44URgoh0fSdK1) ul > li ul > li ul > li ul > li ul > li ul > li {
  list-style: square;
}
:where(.pDwMgleAGdtwIU, .W44URgoh0fSdK1) ol > li {
  list-style: decimal;
}
:where(.pDwMgleAGdtwIU, .W44URgoh0fSdK1) ol > li ol > li {
  list-style: lower-alpha;
}
:where(.pDwMgleAGdtwIU, .W44URgoh0fSdK1) ol > li ol > li ol > li {
  list-style: lower-roman;
}
:where(.pDwMgleAGdtwIU, .W44URgoh0fSdK1) ol > li ol > li ol > li ol > li {
  list-style: decimal;
}
:where(.pDwMgleAGdtwIU, .W44URgoh0fSdK1) ol > li ol > li ol > li ol > li ol > li {
  list-style: lower-alpha;
}
:where(.pDwMgleAGdtwIU, .W44URgoh0fSdK1) ol > li ol > li ol > li ol > li ol > li ol > li {
  list-style: lower-roman;
}
:where(.pDwMgleAGdtwIU, .W44URgoh0fSdK1) code {
  background-color: var(--ds-background-neutral, #091e420f);
  border-radius: 3px;
  border-style: none;
  box-shadow: none;
  color: var(--ds-text, #172b4d);
  display: inline;
  font-size: 0.875em;
  font-weight: normal;
  overflow-wrap: break-word;
  overflow: auto;
  padding: 2px 0.5ch;
  white-space: pre-wrap;
}
:where(.pDwMgleAGdtwIU, .W44URgoh0fSdK1) pre {
  background: var(--ds-background-neutral, #091e420f);
  border-radius: 2px;
  box-shadow: none;
  color: var(--ds-text, #172b4d);
  counter-reset: linenumber;
  display: flex;
  font-size: 12px;
  line-height: 24px;
  margin: 10px 20px 10px 0;
  overflow-x: auto;
  padding: 0;
  position: relative;
}
:where(.pDwMgleAGdtwIU, .W44URgoh0fSdK1) pre > span {
  background: var(--ds-background-neutral, #091e420f);
  flex-shrink: 0;
  padding: 8px;
  text-align: right;
  white-space: normal;
}
:where(.pDwMgleAGdtwIU, .W44URgoh0fSdK1) pre > span i::before {
  color: var(--ds-text-subtle, #44546f);
  content: counter(linenumber);
  text-align: center;
}
:where(.pDwMgleAGdtwIU, .W44URgoh0fSdK1) pre > span i {
  counter-increment: linenumber;
  display: flex;
  font-style: normal;
  justify-content: flex-end;
}
:where(.pDwMgleAGdtwIU, .W44URgoh0fSdK1) pre code {
  background: transparent;
  border-radius: 0;
  color: var(--ds-text, #172b4d);
  cursor: text;
  font-size: 1em;
  height: 100%;
  line-height: 24px;
  padding: 8px;
  white-space: pre;
}
:where(.pDwMgleAGdtwIU, .W44URgoh0fSdK1) .G3dKxzBqsFjo3X ol > li,
:where(.pDwMgleAGdtwIU, .W44URgoh0fSdK1) .G3dKxzBqsFjo3X ul > li {
  list-style: none;
}
:where(.pDwMgleAGdtwIU, .W44URgoh0fSdK1) .pClbawBeQ08q0F {
  background: var(--ds-background-neutral, #091e420f);
  border-radius: 20px;
  border: 1px solid transparent;
  color: var(--ds-text-subtle, #44546f);
  cursor: pointer;
  display: inline;
  font-size: 1em;
  font-weight: normal;
  line-height: 1.714;
  padding: 0px 0.3em 2px 0.23em;
  word-break: break-word;
}
:where(.pDwMgleAGdtwIU, .W44URgoh0fSdK1) .pClbawBeQ08q0F._iYSEmjV8CoxrP {
  background: var(--ds-background-brand-bold, #0c66e4);
  color: var(--ds-text-inverse, #ffffff) !important;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"markeddown": `pDwMgleAGdtwIU`,
	"markdown": `W44URgoh0fSdK1`,
	"atlaskit-smart-link": `G3dKxzBqsFjo3X`,
	"atMention": `pClbawBeQ08q0F`,
	"me": `_iYSEmjV8CoxrP`
};
export default ___CSS_LOADER_EXPORT___;
